import api from './axios';

export const listarHierarquia = () => api.get('/catalogo/secoes');

export const criarSecao = (data) => api.post('/catalogo/secoes', data);

export const criarSubsecao = (data) => api.post('/catalogo/subsecoes', data);
export const atualizarSubsecao = (idSubsecao, data) => api.patch(`/catalogo/subsecoes/${idSubsecao}`, data);

export const criarRequisito = (data) => api.post('/catalogo/requisitos', data);
export const atualizarRequisito = (idRequisito, data) => api.patch(`/catalogo/requisitos/${idRequisito}`, data);
